// components/PermissionControlledCard.jsx
import React from "react";
import PremiumOverlayCard from "./PremiumOverlayCard";

const PermissionControlledCard = ({ permission, children,colClass="col-12 col-md-6 col-lg-6" }) => {
  const shouldRender = permission?.display || permission?.allowed;
  const showOverlay = !(permission?.display && permission?.allowed);

  if (!shouldRender) return null;
  return (
    <div className={colClass}>
      <PremiumOverlayCard showOverlay={showOverlay}>
        {children}
      </PremiumOverlayCard>
    </div>
  );
};

export default PermissionControlledCard;
